export default "/fonts/Acrom-Thin.ttf?a0f8f42c02217f5fe00977ebf0b04e15";